import { Box, Divider, Grid, Tooltip, Typography, useTheme } from "@mui/material";
import { EditNoteOutlined } from "@mui/icons-material";
import useStyles from "./styles";
import ConfusedMale from "../../../../../components/artsPersonComponent/confusedMale";
import FormularioPreview from "./FormularioPreview";
import AnexosPreview from "./AnexosPreview";
import DiagramaPreview from "./DiagramaPreview";

// Copia um campo para a área de transferência e notifica via snackbar. Usado
// por quase todo bloco JSX de FormularioPreview e também aqui (seção
// Observações Finais) — mora em previewData/index.js como export nomeado
// para não duplicar a função em cada subcomponente (decisão do controlador,
// Task 7 da decomposição; função idêntica à que vivia dentro de
// previewData.js).
export async function CopyTexto({ campo, setSnackbar }) {
	try {
		await navigator.clipboard.writeText(campo);
	} catch (err) {
		const textArea = document.createElement("textarea");
		textArea.value = campo;
		document.body.appendChild(textArea);
		textArea.select();
		try {
			document.execCommand("copy");
		} catch (err) {
			console.error("Falha ao copiar texto: ", err);
		}
		document.body.removeChild(textArea);
	}
	setSnackbar({
		children: "Campo copiado!",
		severity: "info",
	});
}

// Composição do modo visualização (read-only) do circuito: mesmas fronteiras
// já aplicadas ao modo edição na Task 6 (FormularioTab/AnexosTab/DiagramaTab)
// — Rede...Meio de Entrega em FormularioPreview, Anexos em AnexosPreview,
// Observações Finais aqui mesmo (acompanha o container, como no modo edição)
// e Diagrama em DiagramaPreview. Extraído de previewData.js (Task 7 da
// decomposição), mesma ordem/JSX/comportamento.
// A partir da introdução das abas do preview, a montagem passa a ser
// condicional por abaAtiva (mesmo padrão de CircuitoTabs no modo edição), em
// vez de empilhar tudo — a barra de Tabs visível fica em serviceItem.js.
export default function PreviewData({
	form,
	setSnackbar,
	clientCpes,
	clientHosts,
	servico,
	isActive = true,
	abaAtiva = 0,
}) {
	const theme = useTheme();
	const styles = useStyles(theme);

	return (
		<>
			{form ? (
				<>
					{/* Aba 0 - Formulário: seções de dados cadastrais/velocidades/equipamentos + Observações Finais, mesmo critério do modo edição (circuito/index.js) */}
					{abaAtiva === 0 && (
						<>
							<FormularioPreview
								form={form}
								clientCpes={clientCpes}
								servico={servico}
								setSnackbar={setSnackbar}
							/>

							<Divider sx={styles.divider} />
							<Box sx={styles.boxContent}>
								<EditNoteOutlined color="primary" />
								<Typography variant="mySubtitle2">Observações Finais :</Typography>
							</Box>
							<Grid container spacing={1} columns={12}>
								<Grid item xs={12}>
									<Box sx={styles.boxCampos}>
										<Tooltip title="Clique para copiar">
											<Typography
												sx={styles.observationsTypography}
												onClick={() =>
													CopyTexto({ campo: form?.observations || "-", setSnackbar })
												}
											>
												{form?.observations || "-"}
											</Typography>
										</Tooltip>
									</Box>
								</Grid>
							</Grid>
						</>
					)}

					{/* Aba 1 - Anexos */}
					{abaAtiva === 1 && <AnexosPreview form={form} setSnackbar={setSnackbar} />}

					{/* Aba 2 - Diagrama de equipamentos */}
					{abaAtiva === 2 && (
						<DiagramaPreview
							form={form}
							clientHosts={clientHosts}
							servico={servico}
							isActive={isActive}
						/>
					)}
				</>
			) : (
				<ConfusedMale
					mainFill={theme.palette.secondary.dark}
					primaryCircleFill={theme.palette.secondary.main}
					highlightTitle={"Oops!"}
					subtitle={`Parece que não\nencontramos nenhum\ncircuito cadastrado.`}
				/>
			)}
		</>
	);
}
